<ng-container [formGroup]="form">
  <div class="d-flex flex-column flex-md-row align-items-lg-center">
    <div class="col col-md-4">
      <label class="required fw-medium">{{
        flexShift
          ? ('work.shift.andWeekdays' | baseBusinessKey | translate)
          : ('externalEmployees.masterData.shiftReadiness.weekdays' | translate)
      }}</label>
    </div>
    <div class="d-flex gap-2 flex-column">
      <div formGroupName="dates">
        <div
          formGroupName="weekdays"
          class="col d-flex flex-column"
        >
          <div class="d-flex gap-2">
            <ng-container *ngFor="let weekday of weekdaysArray">
              <base-checkbox-weekdays
                [formControlName]="weekday"
                [name]="'weekDays.' + weekday"
                [tooltip]="'tooltip.weekDays.' + weekday"
              ></base-checkbox-weekdays>
            </ng-container>
          </div>
        </div>
      </div>
      <div
        *ngIf="flexShift"
        class="d-flex flex-column flex-lg-row align-items-lg-center"
        formGroupName="shiftsAndPersons"
      >
        <div
          formGroupName="shifts"
          class="col d-flex gap-2"
        >
          <ng-container *ngFor="let shift of shifts">
            <base-checkbox-weekdays
              [formControlName]="shift"
              [icon]="'fa-regular ' + baseShiftIconsEnum[shift]"
              [tooltip]="'shiftTimes.labelLong.' + shift | baseBusinessKey"
            ></base-checkbox-weekdays>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!flexShift && form.controls.dates.controls.weekdays.hasError('invalidWeekdays') && submitted"
    class="font-red font-size-sm offset-md-4 col pt-2"
  >
    {{ 'validation.weekdays' | translate }}
  </div>

  <div
    *ngIf="flexShift && form.controls.shiftsAndPersons.controls.shifts.hasError('invalidShifts') && submitted"
    class="font-red font-size-sm offset-lg-4 col pt-2"
  >
    {{ 'validation.weekdaysAndShifts' | baseBusinessKey | translate }}
  </div>

  <div class="d-flex col offset-md-4 mt-1">
    <div class="d-flex align-items-baseline justify-content-center">
      <span class="d-inline-block rounded w-8px h-8px bg-primary me-1"></span>
      <div>{{ 'work.shift.selected' | translate }}</div>
    </div>
    <div class="d-flex align-items-baseline justify-content-center ps-3">
      <span class="d-inline-block rounded w-8px h-8px bg-light-gray me-1"></span>
      <div>{{ 'work.shift.unselected' | translate }}</div>
    </div>
  </div>
  <hr />
</ng-container>
